import type { ReactNode } from 'react'

import { ArrowRight } from 'lucide-react'
import { useInView } from '@/hooks/use-in-view'
import FadeIn from '@/components/generals/fade-in'
import LineReveal from '@/components/generals/line-reveal'
import TransitionLink from '@/components/generals/transition-link'
import Glass from '@/components/landing/sans-alcool/glass'

const SansTeaser = (): ReactNode => {
    const { ref, inView } = useInView<HTMLDivElement>({ rootMargin: '0px 0px -25% 0px' })

    return (
        <section id='sans-alcool' aria-labelledby='sans-teaser-title' className='relative overflow-hidden border-y border-ivory/[0.06] py-28 md:py-44'>
            <div
                aria-hidden='true'
                className='pointer-events-none absolute inset-0 bg-[radial-gradient(45%_60%_at_78%_50%,rgb(201_171_124/0.08),transparent_70%)]'
            />

            <div className='shell relative grid items-center gap-16 lg:grid-cols-12'>
                <div className='lg:col-span-8'>
                    <p className='caps flex items-center gap-4 text-brass'>
                        <span>Sans Alcool</span>
                    </p>

                    <LineReveal
                        as='h2'
                        id='sans-teaser-title'
                        lines={["Composed like", "a cocktail list.", <em key='without' className='text-ivory/80'>Without the cocktail.</em>]}
                        className='mt-8 font-heading text-[clamp(2.7rem,7.4vw,7.25rem)] leading-[0.95] tracking-[-0.035em]'
                    />

                    <FadeIn delay={0.4} className='mt-12'>
                        <TransitionLink href='/sans-alcool' className='link-line caps text-ivory'>
                            Enter the bar
                            <ArrowRight aria-hidden='true' className='size-4' strokeWidth={1.25} />
                        </TransitionLink>
                    </FadeIn>
                </div>

                <div
                    ref={ref}
                    data-poured={inView ? 'true' : 'false'}
                    className='drink-card relative mx-auto flex w-full max-w-[220px] justify-center lg:col-span-3 lg:col-start-10'
                >
                    <div
                        aria-hidden='true'
                        className='absolute inset-x-0 bottom-0 h-1/2 bg-[radial-gradient(closest-side,rgb(201_171_124/0.16),transparent)] blur-xl'
                    />
                    <Glass shape='collins' tint='#b8894a' fizzy className='relative h-auto w-full' />
                </div>
            </div>
        </section>
    )
}

export default SansTeaser
